import Server from "../server";
import View from "../framework/view";
import {Order} from "../bo/order";
import template from "../../pugc/map-orders";
import {MapView} from "./map";
import {isDelivery} from "../misc/orders";
import {autocomplete} from "../google/autocomplete";
import jQuery from "jquery";
import LocalDB from "../misc/localdb";
import {plural} from "../misc/utils";
import {ListOrdersNotification} from "./wrb";

export const LOCALDB_PREFIX = "map-orders-view";

export interface Position {
    address: string,
    lat: number,
    lng: number
};

export const DEFAULT_POS = {
    address: "West Row Botanica Boutique Florist",
    lat: -35.279141,
    lng: 149.127910
};

export class MapOrdersView extends View {

    static classname = "map-orders-view";

    private readonly server = Server.instance();

    private ids : string[];

    private orders : Order[] = [];

    private orders_in_bounds : Order[] = [];

    private map = new MapView();

    constructor(ids: string[]) {
        super(MapOrdersView.classname);
        this.ids = ids;
        this.refresh();
    }

    refresh() {
        const q_ = this.server.getOrdersById(this.ids);
        q_.then((d) => {
            const byId : { [id: string]: Order} = {};
            d.forEach((o) => byId[o.id as string] = o);
            const orders = this.ids.map((id) => byId[id]).filter((order) => order);
            const deliveries = orders.filter(isDelivery);
            this.orders = deliveries;
            this.map.setOrders(this.orders);
            // this.boundsChanged();
            this.update();
        });
    }

    getPosition(pos: "origin" | "destination") : Position {
        return LocalDB.instance().get(LOCALDB_PREFIX + pos) || DEFAULT_POS;
    }

    setPosition(pos: "origin" | "destination", data: Position) {
        data.address = data.address.replace(/, Australia$/, "");
        LocalDB.instance().set(LOCALDB_PREFIX + pos, data);
    }

    protected render0(): JQuery<HTMLElement> {

        const origin = this.getPosition("origin");
        const destination = this.getPosition("destination");

        const data = {
            orders: this.orders,
            orders_in_bounds: this.orders_in_bounds,
            map: this.map,
            origin: origin,
            destination: destination,
            plural: plural
        };

        const out = this.pug(template, data);

        this.afterUpdate(() => {

            this.elt().find("input.address").each((index, element) => {
                const elt = jQuery(element);
                const name = elt.attr("name") as "origin" | "destination";

                autocomplete(element as HTMLInputElement).then((autocomplete) => {
                    autocomplete.addListener("place_changed", () => {
                        const place = autocomplete.getPlace();
                        const data = {
                            address: elt.val() as string,
                            lat: place.geometry?.location?.lat() as number,
                            lng: place.geometry?.location?.lng() as number
                        };

                        this.setPosition(name, data);
                    });
                });
            });

            /*
            this.elt().on("bounds_changed", () => {
               this.boundsChanged();
            });
             */
        });

        return out;
    }

    /*
    private boundsChanged() {
        const bounds = this.map && this.map.getBounds();
        this.orders_in_bounds.length = 0;
        for (const order of this.orders) {
            const position = toPosition(order);
            if (! position) {
                continue;
            }
            if (! bounds || bounds.contains(position)) {
                this.orders_in_bounds.push(order);
            }
        }
        console.log(`boundsChanged orders=${this.orders.length} orders_in_bounds=${this.orders_in_bounds.length}`);
        this.update();
    }
     */

    async calcRoute() {
        if (! this.map) {
            return;
        }

        const origin = this.getPosition("origin");
        const destination = this.getPosition("destination");

        const orders = this.orders;

        try {

            const data = await this.map.calcRoute(origin, destination, orders);

            const results = data && data.results;

            if (results) {
                let seconds = 0;
                let metres = 0;
                let stops = 0;

                for (const result of results) {
                    const route = result.routes[0];
                    const legs = route.legs || [];

                    for (const leg of legs) {
                        let s = leg.duration?.value || 0;
                        let m = leg.distance?.value || 0;

                        seconds += s;
                        metres += m;
                        stops += 1;
                    }
                }

                // Handle double counting
                if (results.length > 0) {
                    stops -= results.length;
                }

                this.elt().find(".estimates .distance").text((Math.round(metres / 100) / 10) + " km");
                this.elt().find(".estimates .time").text((Math.round(seconds / 60)) + " minutes");
                this.elt().find(".estimates .legs").text(stops + " " + plural(stops, "stop", "stops"));
                this.elt().find(".estimates").show();
                this.elt().find(".calc").hide();

                console.log(`got ${results.length} results, stops=${stops}`, results);
            }
        } catch (ex) {
            console.log(`failed to calcRoute`, ex);
        }
    }

    public async listRoute() {
        if (! this.orders) {
            return;
        }

        const origin = this.getPosition("origin");
        const destination = this.getPosition("destination");

        let orders: Order[] | undefined = undefined;

        try {

            const data = await this.map.calcRoute(origin, destination, this.orders);
            if (data) {
                orders = data.orderedOrders;
            }

        } catch (err) {
            console.log("Failed to calculate optimum order order", err);
        }

        if (! orders) {
            orders = this.orders;
        }
        if (orders) {
            const ids = orders.map((order) => order.id).filter((id) => id) || "none";
            this.notify(new ListOrdersNotification(ids as string[]));
        }
    }
}

View.on(
    "." + MapOrdersView.classname,
    "click",
    ".calc",
    function(that: MapOrdersView, event, elt) {
        event.preventDefault();
        that.calcRoute();
    });

View.on(
    "." + MapOrdersView.classname,
    "click",
    ".list",
    function(that: MapOrdersView, event, elt) {
        event.preventDefault();
        that.listRoute();
    });
